import { PRODUCT_STATUS } from '/Foundation/React/code/Utilities/ExtranetConstants';

export const UNAVAILABILITY_REASON = {
  DISCONTINUED: 'discontinued',
  NOT_LAUNCHED: 'notLaunched',
  NOT_IN_ASSORTMENT: 'notInAssortment',
  OUT_OF_STOCK: 'outOfStock',
};

export function getUnavailabilityReason({ statusErp, hasAccess, isAvailable, isLaunchOrderable }) {
  if (statusErp === PRODUCT_STATUS.DISCONTINUED) {
    return UNAVAILABILITY_REASON.DISCONTINUED;
  }
  const isLaunchStatus = statusErp === 'Pending' || statusErp === 'Launch ready';
  if (isLaunchStatus && !isLaunchOrderable) {
    return UNAVAILABILITY_REASON.NOT_LAUNCHED;
  }
  if (hasAccess === false) {
    return UNAVAILABILITY_REASON.NOT_IN_ASSORTMENT;
  }
  if (!isLaunchStatus && isAvailable === false) {
    return UNAVAILABILITY_REASON.OUT_OF_STOCK;
  }
  return null;
}

export function getUnavailabilityMessage(signals, translations) {
  const reason = getUnavailabilityReason(signals);
  if (!reason || !translations) return null;
  switch (reason) {
    case UNAVAILABILITY_REASON.DISCONTINUED:
      return translations.ItemDiscontinued ?? translations.ArticleDiscontinued;
    case UNAVAILABILITY_REASON.NOT_LAUNCHED:
      return translations.NewComingSoon;
    case UNAVAILABILITY_REASON.NOT_IN_ASSORTMENT:
      return translations.NotInAssortment;
    case UNAVAILABILITY_REASON.OUT_OF_STOCK:
      return translations.OutOfStock;
    default:
      return null;
  }
}
